<template>
	<div id="app">
		<audio controls id="audio" ref="audio" src="" style="height: 0; float: left"></audio>
		<router-view />
		<el-dialog title="提示" :visible.sync="voiceDialog" width="30%" :show-close="false">
			<span>允许有新订单播放通知提示音</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="allowVoicePlay">取 消</el-button>
				<el-button type="primary" @click="allowVoicePlay">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				voiceDialog: false,
				audio: "",
				socket: null,
				socketSendTimer: null,
				isConnect: false,
				reConnectTimer: null,
			};
		},
		watch: {
			$route() {
				if (!sessionStorage.getItem("token")) {
					clearInterval(this.socketSendTimer);
					this.isConnect = false;
					this.scoket && this.socket.close();
				} else {
					this.createSocket();
				}
			},
		},
		mounted() {
			this.audio = this.$refs.audio;
			setTimeout(() => {
				if (this.$route.path !== "/Login" && sessionStorage.getItem("token"))
					this.voiceDialog = true;
			}, 1000);
			this.createSocket(); // websocket 创建连接
		},
		methods: {
			createSocket() {
				try {
					if (typeof WebSocket === "undefined") {
						alert("您的浏览器不支持socket");
					} else {
						if (this.isConnect) return;
						let token = sessionStorage.getItem("token");
						if (!token || token === 'null') return
						let socketBaseUrl = this.axios.defaults.baseURL.slice(7);
						socketBaseUrl = socketBaseUrl.slice(0, socketBaseUrl.length - 1);
						let path = `ws://${socketBaseUrl}2/im/${token}`;
						console.log(`socket开始请求---ws://${socketBaseUrl}/im/${token}`);
						this.socket = new WebSocket(path); // 实例化socket
						this.init();
					}
				} catch (error) {
					console.log("创建连接失败");
					// 如果无法连接上webSocket 那么重新连接！可能会因为服务器重新部署，或者短暂断网等导致无法创建连接
					this.reConnect();
				}
			},
			reConnect() {
				// 重连函数
				if (this.isConnect) return;
				// 延迟5秒重连  避免过多次过频繁请求重连
				this.reConnectTimer && clearTimeout(this.reConnectTimer);
				this.reConnectTimer = setTimeout(() => {
					this.createSocket();
				}, 5000);
			},
			init() {
				// 初始化
				this.isConnect = true;
				this.socket.onopen = this.open; // 监听socket连接
				this.socket.onerror = this.error; // 监听socket错误信息
				this.socket.onmessage = this.getMessage; // 监听socket消息
				this.socket.onclose = this.close; // 监听socket关闭
			},
			open() {
				this.send();
			},
			error() {
				console.log("socket连接错误");
				clearInterval(this.socketSendTimer);
				this.isConnect = false;
				this.reConnect();
			},
			getMessage(msg) {
				if (msg.data !== "received") {
					let data = JSON.parse(msg.data);
					if (data) {
						let _this = this; //函数作用域问题
						setTimeout(() => {
							const h = _this.$createElement;
							this.$notify({
								title: "订单审核通知",
								message: h(
									"i", {
										style: "color: red"
									},
									data.orderId + data.message + "!!!"
								),
								// message: data.orderId+data.message,
								dangerouslyUseHTMLString: true,
								duration: "3000",
								position: "bottom-right",
								// duration: 120000,
								// onClick() {
								// _this.defineCallBack(data.data.order_no); //自定义回调,message为传的参数
								// }
							});
							if (data.message === "您有新的派单需要审核") {
								this.audio.src = require("@/assets/send_order.mp3");
							} else {
								this.audio.src = require("@/assets/send_order.mp3");
							}
							this.audio.play();
						}, 3000);
					}
				}
			},
			defineCallBack(order_no) {
				localStorage.setItem("joker1", 1);
				this.$router.push({
					path: "/order/lists",
					query: {
						order_no: order_no,
					},
				});
			},
			send() {
				if (this.socketSendTimer) {
					clearInterval(this.socketSendTimer);
					this.socketSendTimer = null;
				}
				let token = sessionStorage.getItem("token");
				this.socketSendTimer = setInterval(() => {
					let params = {
						message: token,
					};
					//添加状态判断，当为OPEN时，发送消息
					if (this.socket.readyState === 1) {
						if (token && token !== 'null') {
							this.socket.send(JSON.stringify(params));
						}
					}
					if (!sessionStorage.getItem("token")) {
						clearInterval(this.socketSendTimer);
						this.isConnect = false;
						this.socket.close();
					}
				}, 15 * 1000);
			},
			close(e) {
				console.log(`socket已经关闭---${e.code}`);
				clearInterval(this.socketSendTimer);
				this.isConnect = false;
				this.reConnect();
			},
			allowVoicePlay() {
				this.audio.src = require("@/assets/send_order.mp3");
				this.voiceDialog = false;
			},
		},
	};
</script>
<style>
	/* 基础公共样式 */
	@import "./assets/publicCss/base.css";
	/*element组件样式 */
	@import "./assets/publicCss/elementBase.css";
	/*字体图标*/
	@import "./assets/icons/iconfont.css";
</style>
